// extracted by css-extract-rspack-plugin
export default {"tableRoot":"table-module__tableRoot__SUR3m","tableBodyContainer":"table-module__tableBodyContainer__lNGZQ","fixedOmnibar":"table-module__fixedOmnibar__av1lx"};